<div class="cf-dlg" [class.ctr-page]="!isDialog">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>store</mat-icon></div>
    <div class="ctr-header-text">
      <h2 class="cf-dlg-title">Centros</h2>
      <p class="cf-dlg-subtitle">Centros del contacto{{ showFaceFields ? ' · incluye datos FACe' : '' }}</p>
    </div>
    <button *ngIf="isDialog" mat-icon-button class="cf-dlg-close" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando centros…"></app-loading-state>

  <ng-container *ngIf="ready">
    <div class="cf-dlg-body">
      <div class="ctr-state ctr-state--error" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <p class="ctr-state__title">No se pudieron cargar los centros</p>
        <button mat-button class="cf-btn" (click)="load()">
          <mat-icon>refresh</mat-icon> Reintentar
        </button>
      </div>

      <div class="ctr-state" *ngIf="!loadError && empty">
        <mat-icon>storefront</mat-icon>
        <p class="ctr-state__title">Este contacto no tiene centros</p>
        <p class="ctr-state__sub">Pulsa «Nuevo centro» para añadir el primero.</p>
      </div>

      <div class="ctr-list" *ngIf="!loadError && !empty">
        <div class="ctr-row" *ngFor="let item of dataSource; trackBy: trackByUid">
          <div class="ctr-row__icon"><mat-icon>store</mat-icon></div>
          <div class="ctr-row__info">
            <div class="ctr-row__name">
              {{ item.name || 'Sin nombre' }}
              <span class="ctr-code" *ngIf="item.code">{{ item.code }}</span>
            </div>
            <div class="ctr-row__meta">
              <span *ngIf="item.address"><mat-icon>place</mat-icon>{{ item.address }}</span>
              <span *ngIf="location(item)">{{ location(item) }}</span>
              <span *ngIf="item.phone"><mat-icon>phone</mat-icon>{{ item.phone }}</span>
              <span *ngIf="item.email"><mat-icon>email</mat-icon>{{ item.email }}</span>
              <span class="ctr-badge" *ngIf="showFaceFields && item.administrativeCentres?.length"><mat-icon>account_balance</mat-icon> FACe</span>
            </div>
          </div>
          <div class="ctr-row__actions">
            <button mat-icon-button class="ctr-row__btn" (click)="edit(item)" title="Editar" aria-label="Editar centro">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="ctr-row__btn ctr-row__btn--danger" (click)="delete(item)" title="Eliminar" aria-label="Eliminar centro">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer" *ngIf="isDialog || !loadError">
      <button *ngIf="isDialog" mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button *ngIf="!loadError" mat-flat-button class="cf-dlg-btn-primary" (click)="create()">
        <mat-icon>add</mat-icon> Nuevo centro
      </button>
    </div>
  </ng-container>
</div>
